import enLang from './entries/en-US'
import jaLang from './entries/ja-JP'

const AppLocale = {
  en: enLang,
  ja: jaLang
}

export default AppLocale
